<template>
  <div class="col-12">
    <hr />
    <EditorGroupToggle
      label="Location"
      target="toggleGroupLocation"
      class="mb-4"
      :collapsed="false"
    />
    <div id="toggleGroupLocation" class="collapse show row">
      <div class="col-4 mb-3">
        <Field
          type="text"
          name="location"
          label="Location / Venue"
          v-model="location.location"
        />
      </div>
      <div class="col-4 mb-3">
        <Field
          type="text"
          name="address1"
          label="Address Line 1"
          v-model="location.address1"
        />
      </div>
      <div class="col-4 mb-3">
        <Field
          type="text"
          name="address2"
          label="Address Line 2"
          v-model="location.address2"
        />
      </div>
      <div class="col-4 mb-3">
        <Field type="text" name="city" label="City" v-model="location.city" />
      </div>
      <div class="col-3 mb-3">
        <StateField
          name="state"
          label="State/Province"
          v-model="location.state"
        />
      </div>
      <div class="col-2 mb-3">
        <Field
          type="text"
          name="zip"
          label="Zip/Postal Code"
          v-model="location.zip"
        />
      </div>
      <div class="col-3 mb-3">
        <CountryField
          name="country"
          label="Country"
          v-model="location.country"
        />
      </div>
    </div>

    <hr />
    <EditorGroupToggle
      label="Course Materials Shipping"
      target="toggleGroupShipping"
      class="mb-4"
      :collapsed="false"
    />
    <div id="toggleGroupShipping" class="collapse show row">
      <div class="col-4 mb-3">
        <Field
          type="text"
          name="shipping_contact"
          label="Contact Person"
          :value="event.shipping_contact"
        />
      </div>
      <div class="col-4 mb-3">
        <Field
          type="text"
          name="shipping_phone"
          label="Phone Number"
          :value="event.shipping_phone"
        />
      </div>
      <div class="col-12 mb-3">
        <Field
          type="checkbox"
          name="use_location_for_shipping"
          id="cb_use_location_for_shipping"
          label="The shipping address is the same as the event location"
          v-model="useLocationForShipping"
          :checkbox-value="1"
        />
      </div>
      <div class="col-4 mb-3">
        <Field
          type="text"
          name="shipping_location"
          label="Location / Venue"
          v-model="shipping.location"
          :readonly="useLocationForShipping"
        />
      </div>
      <div class="col-4 mb-3">
        <Field
          type="text"
          name="shipping_address1"
          label="Address Line 1"
          v-model="shipping.address1"
          :readonly="useLocationForShipping"
        />
      </div>
      <div class="col-4 mb-3">
        <Field
          type="text"
          name="shipping_address2"
          label="Address Line 2"
          v-model="shipping.address2"
          :readonly="useLocationForShipping"
        />
      </div>
      <div class="col-4 mb-3">
        <Field
          type="text"
          name="shipping_city"
          label="City"
          v-model="shipping.city"
          :readonly="useLocationForShipping"
        />
      </div>
      <div class="col-3 mb-3">
        <StateField
          name="shipping_state"
          label="State/Province"
          v-model="shipping.state"
          :readonly="useLocationForShipping"
        />
      </div>
      <div class="col-2 mb-3">
        <Field
          type="text"
          name="shipping_zip"
          label="Zip/Postal Code"
          v-model="shipping.zip"
          :readonly="useLocationForShipping"
        />
      </div>
      <div class="col-3 mb-3">
        <CountryField
          name="shipping_country"
          label="Country"
          v-model="shipping.country"
          :readonly="useLocationForShipping"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    event: { type: Object, required: true },
  },

  data() {
    return {
      location: {
        location: null,
        address1: null,
        address2: null,
        city: null,
        state: null,
        zip: null,
        country: null,
      },
      shipping: {
        location: null,
        address1: null,
        address2: null,
        city: null,
        state: null,
        zip: null,
        country: null,
      },
      useLocationForShipping: false,
    };
  },

  watch: {
    location: {
      handler: function (val) {
        if (this.useLocationForShipping) {
          this.shipping = _.cloneDeep(this.location);
        }
      },
      deep: true,
    },
    useLocationForShipping(val) {
      if (!!this.useLocationForShipping) {
        this.shipping = _.cloneDeep(this.location);
      }
    },
  },

  created() {
    this.location.location = this.event.location || null;
    this.location.address1 = this.event.address1 || null;
    this.location.address2 = this.event.address2 || null;
    this.location.city = this.event.city || null;
    this.location.state = this.event.state || null;
    this.location.zip = this.event.zip || null;
    this.location.country = this.event.country || "US";
    this.shipping.location = this.event.shipping_location || null;
    this.shipping.address1 = this.event.shipping_address1 || null;
    this.shipping.address2 = this.event.shipping_address2 || null;
    this.shipping.city = this.event.shipping_city || null;
    this.shipping.state = this.event.shipping_state || null;
    this.shipping.zip = this.event.shipping_zip || null;
    this.shipping.country = this.event.shipping_country || "US";
    this.useLocationForShipping = !!this.event.use_location_for_shipping;
  },
};
</script>